<template>
    <div class="col-md-12" >
        <template v-if="getCurrentLang() === 'fr'">
            <h4>L’avantage principal d’un Badge de qualité :</h4>
            <p>
            Il vous donnera la priorité sur un autre partenaire à chaque fois que vos enchères seront équivalentes pour une même mission.
            </p>

            <h4>Les autres avantages :</h4>
            <p>
            A partir du Badge Bleu, Chaque Badge vient avec un cadeau surprise :)
            </p>

            <h4>Comment gagner des points ?</h4>
            <ul class="list-group">
                <li>Recharger de 1000{{ $currency.symbol(user.country)}} votre compte avant qu’il ne soit descendu sous les 500{{ $currency.symbol(user.country)}} => +1 point</li>
                <li>Etre choisi 4 jours sur une semaine => +1 point</li>
                <li>Etre choisi 5 jours sur une semaine => +2 point</li>
                <li>Etre choisi 6 jours sur une semaine => +3 point</li>
                <li>Etre choisi samedi ou dimanche => +1 point</li>
                <li>Etre choisi samedi et dimanche => +2 point</li>
                <li>Etre choisi 20 fois sur un mois avec un rayon de 30km => +1 point</li>
                <li>Etre choisi 20 fois sur un mois avec un rayon de 40km => +2 point</li>
                <li>Etre choisi 20 fois sur un mois avec un rayon de 50km => +3 point</li>
                <li>Remplir les comptes de la moitié de vos missions pendant 1 mois (pour alimenter nos statistiques) => +1 point</li>
                <li>Remplir le comptes de 90% de vos missions pendant 1 mois (pour alimenter nos statistiques) => +2 point</li>
                <li>Une évaluation de 1 ou 2 étoiles de la part de votre client => -1 point</li>
            </ul>

            <h4>Comment perdre des points ?</h4>
            <ul class="list-group">
                <li>Laisser votre compte à zero ou en négatif pendant 1 jour => -1 point</li>
                <li>Ne pas etre choisi pendant une semaine complete => -1 point</li>
                <li>Ne pas renseigner la console sur l’etat d’une mission pendant plus de 4h apres l’heure du rdv => -1 point</li>
                <li>Une plainte recue qui arrive chez nous de la part de votre client => -1 point</li>
                <li>Une évaluation de 1 ou 2 étoiles de la part de votre client => -1 point</li>
            </ul>
        </template>
        <template v-if="getCurrentLang() === 'nl'">
            <h4>Het belangrijkste voordeel van een Kwaliteits Badge :</h4>
            <p>
                Elke keer als uw bod gelijk is aan het bod van een andere partner, krijgt u voorrang.
            </p>

            <h4>De andere voordelen :</h4>
            <p>
                Vanaf de Blauwe Badge elke nieuwe Badge komt met een verrassingsgeschenk  :)
            </p>

            <h4>Hoe verdient u de punten ?</h4>
            <ul class="list-group">
                <li>Uw balans bijvullen voor 1000{{ $currency.symbol(user.country)}} voordat het 500{{ $currency.symbol(user.country)}} niveau bereikt => +1 punt</li>
                <li>4 keer gekozen zijn in 1 week => +1 punt</li>
                <li>5 keer gekozen zijn in 1 week => +2 punten</li>
                <li>6 keer gekozen zijn in 1 week => +3 punten</li>
                <li>Gekozen zijn op zaterdag of zondag => +1 punt</li>
                <li>Gekozen zijn op zaterdag en zondag => +2 punten</li>
                <li>20 keer gekozen zijn in 1 maand met een straal van 30km => +1 punt</li>
                <li>20 keer gekozen zijn in 1 maand met een straal van 40km => +2 punten</li>
                <li>20 keer gekozen zijn in 1 maand met een straal van 50km => +3 punten</li>
                <li>Gedurende 1 maand de helft van de jobs invullen (voor onze statistieken) => +1 punt</li>
                <li>Gedurende 1 maand 90% van de jobs invullen (voor onze statistieken) => +2 punten</li>
            </ul>

            <h4>Hoe verliest u de punten ?</h4>
            <ul class="list-group">
                <li>Uw balans op 0 of in het rood laten staan voor meer dan 1 dag  => -1 punt</li>
                <li>Niet gekozen zijn voor de ganse week => -1 punt</li>
                <li>De details van de afspraak niet raadplegen maximum 4 uur na de afspraak => -1 punt</li>
                <li>Een klacht over u ontvangen van uw klant => -1 punt</li>
                <li>Een beoordeling van 1 of 2 sterretjes over u van uw klant => -1 punt<li></li></ul>
            </ul>
        </template>
        <template v-if="getCurrentLang() === 'en'">
            <h4>The most important advantage of the Quality Badge :</h4>
            <p>
                Whenever your offer is equal to another partner's offer, you will be given priority.
            </p>

            <h4>The other advantages are :</h4>
            <p>
                Starting from the Blue Badge each new Badge comes with a surprise gift  :)
            </p>

            <h4>How do you earn the points ? </h4>
            <ul class="list-group">
                <li>Top up your balance for 1000{{ $currency.symbol(user.country)}} before reaching the 500{{ $currency.symbol(user.country)}} level => +1 point</li>
                <li>Being selected 4 times in 1 week => +1 point</li>
                <li>Being selected 5 times in 1 week => +2 points</li>
                <li>Being selected 6 times in 1 week => +3 points</li>
                <li>Being selected on Saturday or Sunday => +1 point</li>
                <li>Being selected on Saturday and Sunday => +2 points</li>
                <li>Being selected 20 times in 1 month with a radius of 30km => +1 point</li>
                <li>Being selected 20 times in 1 month with a radius of 40km => +2 points</li>
                <li>Being selected 20 times in 1 month with a radius of 50km => +3 points</li>
                <li>Fill in half of the jobs during 1 month (for our statistics) => +1 point</li>
                <li>Fill in 90% of the jobs during 1 month (for our statistics) => +2 points</li>
            </ul>

            <h4>How do you lose the points ?</h4>
            <ul class="list-group">
                <li>Leave your balance at 0 or in the red for more than 1 day => -1 point</li>
                <li>Not be selected for the entire week => -1 point</li>
                <li>Do not consult the details of the appointment maximum 4 hours after the appointment => -1 point</li>
                <li>Complaint about you received from your customer => -1 point</li>
                <li>A 1 or 2 stars rating about you received from your customer => -1 point</li>
            </ul>
        </template>
    </div>
</template>

<script>

    export default {
        props: {
        	user:Object
        },
        data() {
            return {

            }
        },
        created(){

        },
        methods: {
            getCurrentLang(){
				return window.lang;
            }
        },
        computed: {

        },
    }

</script>

<style scoped>
.list-group li{
    list-style: disc;
    font-size: 12px;
    margin-bottom: 10px;
    margin-left: 15px;
}
</style>
